import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQuery } from './createBaseQuery';

export interface ITagCategory {
  id: string;
  name: string;
  description?: string;
}

export const tagsCategoriesApi = createApi({
  reducerPath: 'tagsCategoriesApi',
  baseQuery: createBaseQuery(),
  endpoints: (builder) => ({
    getTagsCategories: builder.query<ITagCategory[], void>({
      query: () => ({
        url: '/tags-categories',
        method: 'GET',
      }),
    }),

    createTagCategory: builder.mutation<ITagCategory, Omit<ITagCategory, 'id'>>({
      query: (data) => ({
        url: '/tags-categories',
        method: 'POST',
        body: data,
      }),
    }),

    updateTagCategory: builder.mutation<ITagCategory, ITagCategory>({
      query: (data) => ({
        url: `/tags-categories/${data.id}`,
        method: 'POST',
        body: data,
      }),
    }),

    deleteTagCategory: builder.mutation<void, string>({
      query: (id) => ({
        url: `/tags-categories/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetTagsCategoriesQuery,
  useCreateTagCategoryMutation,
  useUpdateTagCategoryMutation,
  useDeleteTagCategoryMutation,
  useLazyGetTagsCategoriesQuery
} = tagsCategoriesApi;
